import { loadFirestore } from '@/utils/loadFirestore'

// Fire-and-forget failure record in the `clientLogs` collection. Never throws:
// a logging failure must not break the save flow it observes.
export function logClientEvent(evt, { uid, host = '', outcome, detail = '' }) {
  loadFirestore().then(({ db, addDoc, collection, serverTimestamp }) => {
    return addDoc(collection(db, 'clientLogs'), { evt, uid, host, outcome, detail, createdAt: serverTimestamp() })
  }).catch(() => { /* never rethrow */ })
}
